/**
 * Front-end behavior for Heading (scoped to block instances).
 */
export class HeadingFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		this.root.querySelectorAll( '[data-block="heading"]' ).forEach( ( el ) => {
			el.classList.add( 'heading-enhanced' );
		} );
	}
}
